import Vue from "vue";
import VueRouter from "vue-router";

import myHelper from "./helpers/myHelper.js";
import { VTooltip } from "v-tooltip";

import store from "./store";

const VueScrollTo = require("vue-scrollto");
const moment = require("moment");

Vue.use(require("vue-moment"), {
  moment,
});

Vue.use(myHelper);
Vue.use(VueScrollTo);
Vue.use(VueRouter);

VTooltip.options.defaultTrigger =
  window.innerWidth > 768 ? "hover focus click" : "click";
VTooltip.options.defaultBoundariesElement = "window";

Vue.directive("tooltip", VTooltip);

const appexists = document.querySelector(".v-app");

const router = new VueRouter({
  mode: "history",
  base: window.location.pathname,
  routes: [{ path: "" }],
});

if (appexists) {
  const app = new Vue({
    router,
    el: ".v-app",
    store,
    components: {
      Greyjoy: () => import("./components/Greyjoy.vue"),
      Vouchery: () => import("./components/Vouchery.vue"),
      RezervaceObjednavky: () => import("./components/RezervaceObjednavky.vue"),
      Objednatele: () => import("./components/Objednatele.vue"),
      Popup: () => import("./components/Popup.vue"),
      TermsOverview: () => import("./components/TermsOverview.vue"),
      SearchResult: () => import("./containers/SearchResult.vue"),
      GlobalFilter: () => import("./components/GlobalFilter.vue"),
      Branches: () => import("./components/pobocky/Branches"),
      SimpleGallery: () => import("./components/SimpleGallery.vue"),
      SimpleMap: () => import("./components/SimpleMap.vue"),
      GlobalFilterLauncher: () => import("./components/GlobalFilterLauncher.vue"),
      TripCardList: () => import("./components/TripCardList.vue"),
      ResortCardList: () => import("./components/ResortCardList.vue"),
      LoadMore: () => import("./components/LoadMore"),
      ResortFacilities: () => import("./components/common/ResortFacilities"),
    },
    mounted: function(){
      this.$nextTick(()=>{
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.onload = function(){
          console.log("Persoo loaded");
        };
        let body = document.getElementsByTagName('body')[0];
        let html = document.getElementsByTagName('html')[0];
        let lang = html.getAttribute("lang");
        script.src = window.location.protocol + "//" + window.location.host + `/Scripts/source/js/persoo_${lang}.js`;
        body.appendChild(script);
      });
    }
  });
  window.app = app;
}
